import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SpinnerComponent } from '../../../spinner/spinner.component';

@Component({
    selector: 'app-content-loading',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="content-loading-wrapper">
      @if (loading()) {
        <div class="loading-overlay" @fadeIn @fadeOut>
          <app-spinner type="infinitform" />
        </div>
      }
      <div class="content-body" [class.is-loading]="loading()">
        <ng-content />
      </div>
    </div>
  `,
    styles: [`
    .content-loading-wrapper { position: relative; flex: 1; display: flex; flex-direction: column; min-height: 12rem; }
    .loading-overlay { position: absolute; inset: 0; z-index: 10; display: flex; align-items: center; justify-content: center; }
    .content-body { display: flex; flex-direction: column; flex: 1; transition: opacity 0.15s ease; }
    .content-body.is-loading { opacity: 0.3; pointer-events: none; }
  `],
    imports: [SpinnerComponent],
    animations: [
        trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('150ms ease', style({ opacity: 1 }))])]),
        trigger('fadeOut', [transition(':leave', [animate('150ms ease', style({ opacity: 0 }))])])
    ]
})
export class ContentLoadingComponent {
    loading = input(false);
}
